import type { FC } from 'react'

import { RouterProvider } from '@tanstack/react-router'

import { router } from '@/app/router/instance'

export const AppRouter: FC = () => <RouterProvider router={router} />
